<template>
  <div class="hello bg-white p-0 mb-3 fixed-top" style="box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">

    <header class="navbar navbar-expand-md navbar-dark  bd-navbar" >
  <nav class="container-fluid flex-wrap flex-md-nowrap " aria-label="Main navigation">
    <a class="navbar-brand p-0 me-2" href="/" aria-label="Bootstrap">
              <img src="@/assets/images/Logo.jpg" style="width:52px;height:52px;"/>

    </a>

    <button class="navbar-toggler bg-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#bdNavbar" aria-controls="bdNavbar" aria-expanded="false" aria-label="Toggle navigation">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" class="bi" fill="currentColor" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
</svg>

    </button>

    <div class="collapse navbar-collapse" id="bdNavbar">
      <ul class="navbar-nav flex-row flex-wrap bd-navbar-nav pt-2 py-md-0">
        <li class="nav-item col-6 col-md-auto">
          <router-link to="/About">About</router-link>
        </li>
        <li class="nav-item col-6 col-md-auto">
          <router-link to="/Courses">Courses</router-link>
        </li>
        <li class="nav-item col-6 col-md-auto">
          <router-link to="/Trading">Trading Blog</router-link>
        </li>

        <li class="nav-item col-6 col-md-auto">
          <router-link to="/Training">Training</router-link>
        </li>
        
      </ul>

      <hr class="d-md-none text-white-50">

      <ul class="navbar-nav flex-row flex-wrap ms-md-auto">
        <li class="nav-item col-6 col-md-auto">
          <a class="nav-link p-2" href="https://twitter.com/bees_trade" target="_blank" rel="noopener">
                  <i class="fs-3 bi bi-twitter "></i>

          </a>
        </li>
        <li class="nav-item col-6 col-md-auto">
          <a class="nav-link p-2" href="https://telegram.me/s/tradebees1" target="_blank" rel="noopener">
                  <i class="fs-3 bi bi-telegram "></i>

          </a>
        </li>
        <li class="nav-item col-6 col-md-auto">
          <a class="nav-link p-2" href="https://www.youtube.com/channel/UC9H5dir7-7etul1bp-i7bAA" target="_blank" rel="noopener">
                  <i class="fs-3 bi bi-youtube "></i>

          </a>
        </li>
        <li class="nav-item col-6 col-md-auto">
          <a class="nav-link p-2" href="https://www.facebook.com/tradebees" target="_blank" rel="noopener">
                 <i class="fs-3 bi bi-facebook "></i>

          </a>
         
        </li>
      </ul>
    <ul class="navbar-nav flex-row flex-wrap bd-navbar-nav pt-2 py-md-0">
        
        <li class="nav-item col-6 col-md-auto" v-if="username==null">
          <router-link to="/Login">Login</router-link>
        </li>
        <li class="nav-item col-6 col-md-auto" v-if="username==null">
          <router-link to="/Register">Register</router-link>
        </li>
        <li class="nav-item col-12 col-md-auto " v-if="username!=null">
          <div class="dropdown">
            <a class="dropdown-toggle mx-2" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
              <span style="text-decoration:none;font-size:small">Hi   {{username}}!</span>
            </a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
               <router-link to="/Customer/Profile">
              <li>
                <a class="dropdown-item">
               Profile
                </a>
              </li>
              </router-link>
              <div v-for="dropdown in dropdowns" :key="dropdown">
                  <router-link class="text-capitalize" :to="{name:dropdown}">
                  <li class="nav-item dropdown-item">
                
                {{dropdown}}
                
              </li>
              </router-link>
              </div>
             <router-link to="/">
              <li>
                <a class="dropdown-item" @click="LogOut()">
                Log Out
                </a>
              </li>
              </router-link>
              </ul>
          </div>
        </li>
        
      </ul>
      
    </div>
  </nav>
</header>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import MenuSet from "@/services/localstorage/MenuLocal"
import { Watch } from "vue-property-decorator";
import {userModule} from '@/store/module/UserStore'
import {PermGet, PermSet} from "@/services/localstorage/UserLocal"
import router from "@/router";
@Options({
  props: {
    prop: String,
  },
  
   
})
export default class NavBar extends Vue {
  
  @Watch('prop')
  OnPropertyChanged(value:string, oldValue:string)
  {
    if(value==null)
    {
    this.username=null
    }
    else
    {
          this.username=MenuSet()
          this.dropdowns=PermGet()
  console.log(this.username, this.dropdowns)
    }
  }
  
  username=MenuSet()
  dropdowns=PermGet()
  LogOut()
  {
    localStorage.clear()
    this.username=null
        router.push("/")

  }
}
</script>
<style scoped>
a{
  color:black;
  text-decoration: none;
  cursor: pointer;
}
  a:hover{
    color: cornflowerblue;
  }
  i{
    color:black;
  }
  i:hover
  {
    color: cornflowerblue;

  }
  .bi-facebook:hover
  {
        color: rgb(0, 67, 190);

  }
  .bi-youtube:hover
  {
    color:red;
  }
</style>
